import { ChangeDetectionStrategy, Component, computed, input, output, type InputSignal, type OutputEmitterRef, type Signal } from '@angular/core';
import { UiButtonComponent } from '@nexus/frontend-shared-ui';
import type { WishlistOverviewSectionView } from '../../types/wishlist-overview-section-view.interface';
import { WishlistRowCardComponent } from '../wishlist-row-card/wishlist-row-card.component';

@Component({
  selector: 'wishlist-overview-list-section',
  imports: [UiButtonComponent, WishlistRowCardComponent],
  templateUrl: './wishlist-overview-list-section.component.html',
  styleUrl: './wishlist-overview-list-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistOverviewListSectionComponent {
  public readonly section: InputSignal<WishlistOverviewSectionView> = input.required<WishlistOverviewSectionView>();
  public readonly showAll: InputSignal<boolean> = input<boolean>(false);
  public readonly rowSelected: OutputEmitterRef<string> = output<string>();
  public readonly allSelected: OutputEmitterRef<void> = output<void>();

  protected readonly hasHiddenRows: Signal<boolean> = computed(
    (): boolean => !this.showAll() && this.section().totalCount > this.section().visibleCount,
  );
  protected readonly summaryLabel: Signal<string> = computed((): string => {
    const section: WishlistOverviewSectionView = this.section();

    return `${section.visibleCount} z ${section.totalCount}`;
  });

  protected handleRowSelected(wishlistId: string): void {
    this.rowSelected.emit(wishlistId);
  }

  protected handleAllSelected(): void {
    this.allSelected.emit();
  }
}
